import { useRef, useState } from "react"
import icomma from "../Assets/icomma.png"
import YouTube from 'react-youtube'
const TestimonialCard=({url,name,text,videourl,setvideourl,swiper})=>
{
    const videoRef=useRef(null)
    
    // const opts = {
    //     width:"100%",
    //     height:"100%",
    //     borderRadius:'10px'
    // }
    // const optsfull = {
    //     height: '100vh',
    //     width: '100vw',
    //     borderRadius:'10px'
    // }
    const handlePlay = () => {
        videourl!=""?swiper.autoplay.start():swiper.autoplay.stop()
       setvideourl(url)
    //    if(videoRef.current)
    //    {
    //     videoRef.current.pauseVideo();
    //    }
       
      }
      return(
        url!=""?
        <div className="lg:w-[45%] md:w-[70%] sm:h-[500px] md:h-[400px] sm:w-[100%] lg:h-[300px] bg-[#FFF8EA] m-auto flex sm:flex-col lg:flex-row justify-center items-center gap-[20px] sm:bg-[#FFF8EA]">
            <div className=" sm:mb-[25px] lg:mb-[0px] flex items-start">
                {/* <div>
                    <img className="" src ={icomma} />
                </div> */}
                <div id="activeeffect" className="cursor-pointer" >
                    {/* <iframe width="853" height="480" src={`https://www.youtube.com/embed/${url}`} onPlay={handlePlay} allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"/> */}
                    {/* <YouTube ref={videoRef} onReady={(e)=>videoRef.current=e.target} videoId={url} onPlay={handlePlay} /> */}
                    <img src={text} className="w-full h-full" onClick={handlePlay}/>
                </div>
                
            </div>
            <p style={{fontFamily:"Inter"}} className="lg:grow bg-[#FFF8EA] sm:text-[16px] lg:text-[20px] lg:text-center font-[500] leading-[30px] tracking-[2px] text-[#D08E02]">{name}</p>
        </div>
        :
        <div className="bg-[#FFF8EA] flex flex-col sm:h-[500px] md:h-[400px] lg:h-[300px] items-center justify-center text-justify sm:my-[0px] sm:px-[0px] lg:my-[0px] lg:mt-[0px] lg:pl-[0px]" style={{fontFamily:"Inter"}}>
                <p className="sm:text-[14px] sm:leading-[26px] md:text-[18px] font-[400] italic md:leading-[30px] text-justify tracking-[1px] mb-[30px]">"{text}"</p>               
               <p className="sm:text-[16px] lg:text-[18px] font-[500] leading-[30px] tracking-[2px] text-[#D08E02]">{name}</p>
         </div>
      )
    // return(
    //         <div className="sm:flex-col lg:flex-row justify-center items-center text-center sm:bg-[#FFF8EA] lg:bg-white lg:flex w-full lg:pt-[28px] sm:pl-[50px] sm:pr-[50px] lg:px-[0px] sm:py-[22px] lg:py-[0px]">
    //             {url?.endsWith('png')?<></>:
    //             <div className="flex items-start lg:w-[30%] sm:justify-center gap-[20px]">
    //             <img src={icomma} />
    //             <div className={expanded?"after":"before"}><YouTube className="video-player" opts={expanded?optsfull:opts} onPlay={handlePlay} videoId={url}></YouTube></div>
                
    //         </div>
    //             }
                
    //             <div className="sm:my-[30px] lg:my-[0px] lg:w-[50%]" style={{fontFamily:"Inter"}}>
    //                 <p style={{display:url?.endsWith('png')?"block":"none"}} className="text-[14px] font-[400] italic leading-[24px] tracking-[1px] mb-[10px]">{text}</p>
    //                 <p className="text-[18px] font-[500] leading-[30px] tracking-[2px] text-[#D08E02]">{name}</p>
    //             </div>
    //     </div>
    // )
}
export default TestimonialCard